import { createAction } from 'redux-actions';
import { ACTION_TYPE_PREFIX } from './constants';
export var initialize = createAction(ACTION_TYPE_PREFIX + ".INITIALIZE");
//# sourceMappingURL=actions.js.map